import request from '@/router/axios'

const pre_fix = "/dotadmin/dotadmin/dataDownload/"

export function getObj() {
  return request({
    url: pre_fix + 'list',
    method: 'get'
  })
}

export function saveLog(body) {
  return request({
    url: pre_fix + 'saveLog',
    method: 'post',
    data: body
  })
}

export function checkExport(body) {
  return request({
    url: pre_fix + 'checkExport',
    method: 'post',
    data: body
  })
}
